/**
 * Product Item Card — Add to Cart handler
 * Handles .product-item__add-cart buttons sitewide (collection grid, featured sections, search, etc.)
 */

(function () {
  const { formatMoney, updateCartCount, bumpCartIcons, notifyAdded } = window.CartFeedback;

  function handleVariantClick(btn) {
    const container = btn.closest('[data-variant-buttons]');
    if (!container) return;

    const card = container.closest('[data-js-product-item]');
    if (!card) return;

    container.querySelectorAll('.product-item__variant-btn').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    const price = parseInt(btn.dataset.price, 10);
    const comparePrice = parseInt(btn.dataset.comparePrice, 10);

    const priceEl = card.querySelector('[data-variant-price]');
    const comparePriceEl = card.querySelector('[data-variant-compare-price]');
    const savingsEl = card.querySelector('[data-variant-savings]');
    const addCartBtn = card.querySelector('.product-item__add-cart');

    if (priceEl) priceEl.textContent = formatMoney(price);

    if (comparePriceEl) {
      if (comparePrice > price) {
        comparePriceEl.textContent = formatMoney(comparePrice);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    if (savingsEl) {
      if (comparePrice > price) {
        savingsEl.textContent = 'Save ' + formatMoney(comparePrice - price);
        savingsEl.classList.remove('product-item__price-savings--hidden');
      } else {
        savingsEl.textContent = '';
        savingsEl.classList.add('product-item__price-savings--hidden');
      }
    }

    if (addCartBtn) {
      addCartBtn.dataset.productId = btn.dataset.variantId;
    }

    const variantImage = btn.dataset.variantImage;
    if (variantImage) {
      const imgEl = card.querySelector('.product-item__img');
      if (imgEl) {
        imgEl.src = variantImage;
        imgEl.srcset = [200, 400, 600, 800]
          .map((w) => variantImage.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w')
          .join(', ');
      }
    }
  }

  async function handleAddToCart(button) {
    const variantId = parseInt(button.dataset.productId, 10);
    const productTitle = button.dataset.productTitle || 'Product';

    if (!variantId) return;

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      updateCartCount();
      bumpCartIcons();

      button.textContent = 'Added!';
      button.style.backgroundColor = '#10b981';

      notifyAdded(productTitle + ' added to cart');

      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = '';
        button.disabled = false;
      }, 2000);
    } catch (err) {
      console.error('Error adding to cart:', err);
      button.textContent = 'Error';
      button.style.backgroundColor = '#ef4444';

      setTimeout(() => {
        button.textContent = originalText;
        button.style.backgroundColor = '';
        button.disabled = false;
      }, 2000);
    }
  }

  function bindDelegatedEvents() {
    if (document._piDelegated) return;
    document._piDelegated = true;

    document.addEventListener('click', (e) => {
      const variantBtn = e.target.closest('.product-item__variant-btn:not(:disabled)');
      if (variantBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleVariantClick(variantBtn);
        return;
      }

      const cartBtn = e.target.closest('.product-item__add-cart[data-product-id]:not(:disabled)');
      if (cartBtn) {
        e.preventDefault();
        handleAddToCart(cartBtn);
      }
    });
  }

  bindDelegatedEvents();
})();
